import React , { Suspense, lazy , useState , useEffect , useContext } from "react";
import { Link , NavLink, Outlet  } from "react-router-dom";
import { WebContext } from "../../Webroute";
const Webassets = React.lazy(() => import('../../Webassets'));
const MyaccountLayout = (props) => {
const WebData = useContext(WebContext);
const HomeContextData = useContext(WebContext);
const [isActive, setisActive] = useState('profile');
  return (
    <>
    <section className="ivo-section my-account">
        <div className="container">
          <div className="row my-account-tabs">
                <div className="col-lg-4">
                    <ul className="nav flex-column nav-tabs " id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <NavLink to="/home/my-account/profile"  className="nav-link"
                             ><span className="tabs-left-icon"><i className="fa-solid fa-user"></i></span> Profile</NavLink>
                        </li>
                        <li className="nav-item" role="presentation">
                            <NavLink to="/home/my-account/management"  className="nav-link">
                                <span className="tabs-left-icon"><i className="fa-solid fa-shield-halved"></i></span> Account
                                Management</NavLink>
                        </li>
                        <li className="nav-item" role="presentation">
                          <NavLink to="/home/my-account/kyc"  className="nav-link">
                            <span
                                    className="tabs-left-icon"><i className="fa-solid fa-folder-open"></i></span> Verify  KYC</NavLink>
                        </li>
                        
                        <li className="nav-item" role="presentation">
                        <NavLink to="/home/my-account/withdraw"  className="nav-link">
                            <span className="tabs-left-icon"><i className="fa-solid fa-money-bill-transfer"></i></span> Withdraw</NavLink>
                        </li>

                        <li className="nav-item" role="presentation">
                        <NavLink to="/home/my-account/activity"  className="nav-link"><span className="tabs-left-icon"><i
                                        className="fa-solid fa-file-pen"></i></span>Login History</NavLink>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button 
                                    className={isActive == 'Activitya' ? 'nav-link active' : 'nav-link'}
                                    onClick={()=> HomeContextData.customerLogout()}

                            ><span className="tabs-left-icon"><i
                                        className="fa fa-sign-out"></i></span>Logout</button>
                        </li>
                       
                    </ul>
                </div>
                <div className="col-lg-8">
                       
                        
                    <div className="tab-content " id="myTabContent ">
                        <div className="tab-pane fade show active">
                              <Outlet /> 
                                {/* {isActive == 'profile' && <Profile /> }
                                {isActive == 'Management' && <Management /> }
                                {isActive == 'Payment' && <Payment /> }
                                {isActive == 'Withdraw' && <Withdraw /> }
                                {isActive == 'Kyc' && <Kyc /> }
                                {isActive == 'Activity' && <Activity /> } */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
};

export default MyaccountLayout;